module.exports = window["MaterialUI"].useMediaQuery;